import React, { createContext, useContext } from "react";

const DpatIndicatorSlugContext = createContext(null);

export function DpatIndicatorSlugProvider({ slug, children }) {
  return (
    <DpatIndicatorSlugContext.Provider value={slug ?? null}>
      {children}
    </DpatIndicatorSlugContext.Provider>
  );
}

export function useDpatIndicatorSlug() {
  return useContext(DpatIndicatorSlugContext);
}

export default DpatIndicatorSlugContext;
